import * as actions from '../actions/premiumSettingsWizard';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import {failedGetCoverageTypes, getCoverageTypes, receiveCoverageTypes } from '../reducers/stagedPremiumsWizard';


//cycle that makes the request to post a new premium setting
export function requestPostPremiumSettingWizard(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.POST_NEW_PREMIUM_SETTING_WIZARD)
        .map(action => ({
            url: BASE_URL + `api/PremiumSettings/${action.payload.premiumSettingTypePercentage ? 'Percentage' : 'Settings'}`,
            category: 'requestPostPremiumSettingWizard',
            method: 'POST',
            send: action.payload,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestPostPremiumSettingWizard')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 201)
        .map(response => actions.receivePostPremiumSettingWizard(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

//cycle that receives failed response from posting premium setting
export function failedToReceivePostResponsePremiumSettingWizard(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestPostPremiumSettingWizard')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 201)
        .map(response => actions.failedToPostPremiumSettingWizard(response));

    return {
        ACTION: httpResponse$
    };
}

//cycle that requests wizard step messages
export function requestPremiumSettingsWizardStepMessages(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_PREMIUM_SETTINGS_WIZARD_STEP_MESSAGES)
        .map(action => ({
            url: BASE_URL + 'api/PremiumSettings/Messages',
            category: 'requestPremiumSettingsWizardStepMessages',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestPremiumSettingsWizardStepMessages')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivePremiumSettingsWizardMessages(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

//cycle that receives failed response from getting premium settings messages
export function failedToReceivePremiumSettingsWizardMessages(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestPremiumSettingsWizardStepMessages')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToGetPremiumSettingsWizardMessages(response));

    return {
        ACTION: httpResponse$
    };
}
export function requestGetCoverageTypes(sources) {
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.GET_COVERAGE_TYPES || action.type === getCoverageTypes.type)
		.map(action => ({
			url: BASE_URL + 'api/CoverageTypes/CoverageTypesOptions',
			category: 'getCoverageTypes',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getCoverageTypes')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => xs.of(actions.receiveCoverageTypes(JSON.parse(response.text)), receiveCoverageTypes(JSON.parse(response.text))))
        .flatten();
        
        
	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failedToGetCoverageTypes(sources) {
	let httpResponse$ = sources.HTTP
		.select('getCoverageTypes')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
        .map(response => xs.of(actions.failedToGetCoverageTypes(response), failedGetCoverageTypes(response)))
        .flatten();

	return {
		ACTION: httpResponse$
	};
}